
import { assertVal } from '../../../CodesThatsGottaGoSomewhereElse';
import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { stringStep } from '../../../concepts/commands/CommandWizard';
import { alert } from '../../packages/alerts/AlertCommands';
import { clearSelection } from '../commands/SelectionCommands';
import { EditorSession } from '../EditorSession';
import { CreateToolInfo, ToolInfo } from '../tooling/ToolInfo';
import { ToolManager } from '../tooling/ToolManager';

export const toolParamDataKey = (toolId: string) => `deqo/editor/${toolId}/param`;

export const toolSetParam = defineCommand(
    'toolSetParam',
    'Tool: Set Param',
    (r, [toolId, name, value]: [string, string, string]) => {
        // Resolve dependencies
        const tools = r.call(ToolManager);

        try {
            value = JSON.parse(value);
        }
        catch {
            // Must be a string
        }

        tools.setSetting(toolId, name, value);
    },
    [
        stringStep('toolId', 'Tool ID:'),
        stringStep('name', 'Param Name:'),
        stringStep('value', 'Param Value:'),
    ]
);

export const toolEquip = defineCommand(
    'toolEquip',
    'Tool: Equip...',
    (r, [toolId, param, keepSelection]: [string, string?, boolean?]) => {

        // Resolve dependencies
        const dispatch = r.call(CommandDispatcher);
        const tools = r.call(ToolManager);
        const session = r.call(EditorSession);

        if (tools.isEnabled(toolId)) {

            const toolDef = tools.get(toolId);
            assertVal(toolDef, 'toolDef');

            // If it's a command tool, invoke the command
            if (toolDef.command) {
                dispatch(toolDef.command);
            }

            // If the tool has behaviors (most do), set the tool info so the tool layer can install the tool
            if (toolDef.behaviors) {
                session.update(ToolInfo, CreateToolInfo(toolDef.id, 'idle', param));
            }

            if (!keepSelection) {
                dispatch(clearSelection);
            }
        }
        else if (toolId !== 'default') {

            dispatch(alert, ['Sorry, the facilitator has disabled this function.']);
        }

    },
    [
        stringStep('toolId', 'Tool ID:', 'default')
    ]
);

export const toolReset = defineCommand(
    'toolReset',
    'Tool: Reset',
    (r) => {
        const dispatch = r.call(CommandDispatcher);
        dispatch(toolEquip, ['default']);
    },
);
